<script>
import MainMenuView from '../../../shared/views/MainMenuView';
import HomeAdminDashboardView from '../dashboards/HomeAdminDashboardView';
import PageHeaderView from '../../../shared/views/PageHeaderView';

export default {
  components: {
    'page-header-view': PageHeaderView,
    'main-menu-view': MainMenuView,
    'home-admin-dashboard-view': HomeAdminDashboardView,
  },
  data() {
    return {};
  },
  methods: {},
};
</script>

<template>
  <div>
    <main-menu-view />
    <div class="wrapper">
      <div class="sa4d25">
        <div class="container-fluid">
          <div class="row">
            <div class="col-xl-12 col-lg-12">
              <div class="section3125">
                <page-header-view
                  icon="fas fa-tachometer-alt"
                  title="Resumen"
                  subtitle="Indicadores de la plataforma y actividad reciente de la comunidad"
                />
                <div class="la5lo1">
                  <home-admin-dashboard-view />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
